/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PracticeHub/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Active from './Active/index'
import Inactive from './Inactive/index'
import No from 'DesignSystem/VideoRecorderNative/No/index'
import NotInvited from './NotInvited/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function PracticeHub({
  children,
  viewPath = "/DesignSystem/LedgerPaymentAccount/PersonPaymentAccount/Payor/Person/Content/Content/PracticeHub"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let personPublicUserValueData = fromData.useDataFormat({ viewPath,
context: 'person',
path: 'public_user',
format: fromHelpers.getView,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: personPublicUserValueData,
})
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral400}
 text="Practice Hub"
/>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Active'}>
<Active
  viewPath={`${viewPath}/Active`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Inactive'}>
<Inactive
  viewPath={`${viewPath}/Inactive`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'NotInvited'}>
<NotInvited
  viewPath={`${viewPath}/NotInvited`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}